import templateStr from 'text!./add-activity.html';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default ['$filter', ($filter) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            accountNumber: '@',
            policyNumber: '@',
            jobNumber: '@',
            productCode: '@',
            config: '=',
            activities: '='
        },
        controller: ['$scope', '$q', '$modal', 'ActivityService', 'ModalService', '$location', 'ViewModelService', ($scope, $q, $modal, ActivityService, ModalService, $location, ViewModelService) => {
            // Create Activity

            $scope.activityPatterns = [];
            $scope.selectedActivityPattern = {};
            $scope.activityInfo = {};
            $scope.activityInfoView = ViewModelService.create($scope.activityInfo, 'pc', 'edge.capabilities.gateway.activity.dto.ActivityDTO');
            $scope.noteInfo = {};
            $scope.priorities = [];
            $scope.assignableUsers = [];
            $scope.today = DateUtil.currentDateAtMidnight();

            $scope.setCreateActivityData = () => {
                if ($scope.accountNumber) {
                    $scope.activityEntity = 'account';
                    $scope.activityEntityId = $scope.accountNumber;
                } else if ($scope.policyNumber) {
                    $scope.activityEntity = 'policy';
                    $scope.activityEntityId = $scope.policyNumber;
                } else if ($scope.jobNumber) {
                    $scope.activityEntity = 'job';

                    $scope.activityEntityId = $scope.jobNumber;
                }
            };

            $scope.getActivityPatternsFor = (actPatternEntity) => {
                const actPromise = ActivityService.getActivityPatternsFor(actPatternEntity);
                $scope.readyToAddActivityPromise = actPromise.then(
                    (activityPatterns) => {
                        $scope.activityPatterns = activityPatterns;
                        $scope.setActivityInfo({});
                        $scope.selectedActivityPattern = null;
                        $scope.priorities = $scope.activityInfoView.priority.aspects.availableValues;

                        return $scope.getAssignableUserForActivity(activityPatterns[0]);
                    },
                    () => {
                        ModalService.showError('gateway.directives.add-activity.ActivityPattern retrieval failed');
                    }
                );
            };

            $scope.getAssignableUserForActivity = (activityPattern) => {
                const actPromise = ActivityService.getAssignableUserForActivity($scope.activityEntity, $scope.activityEntityId, activityPattern);
                return actPromise.then(
                    (activity) => {
                        $scope.assignableUsers = activity.assignableUsers;
                        $scope.activityInfo.selectedAssignee = activity.assignableUsers[0];
                    },
                    () => {
                        ModalService.showError('gateway.directives.add-activity.Activity assignable users retrieval failed');
                    }
                );
            };

            $scope.createNewActivity = (activityForm, noteForm) => {
                if (!$scope.selectedActivityPattern) {
                    ModalService.showError('gateway.directives.add-activity.You must choose an activity type', 'gateway.directives.add-activity.You must first select an activity type');
                    return;
                }

                activityForm.submitted = true;
                if (activityForm.invalid) {
                    return;
                }
                if ($scope.noteInfo.topic) {
                    noteForm.submitted = true;
                    if (noteForm.invalid) {
                        return;
                    }
                } else {
                    $scope.noteInfo = null;
                }
                if ($scope.activityEntity === 'account') {
                    $scope.activityInfo.accountNumber = $scope.activityEntityId;
                } else if ($scope.activityEntity === 'policy') {
                    $scope.activityInfo.policyNumber = $scope.activityEntityId;
                } else if ($scope.activityEntity === 'job') {
                    $scope.activityInfo.jobNumber = $scope.activityEntityId;
                }
                const actPromise = ActivityService.createNewActivity($scope.activityInfo, $scope.noteInfo);
                $scope.createNewActivityPromise = actPromise;

                $q.when(actPromise, (activity) => {
                    if (activity) {
                        // Update activity list
                        ModalService.showInfo('gateway.directives.add-activity.Activity created');

                        $scope.activities.push(activity);
                        $scope.closeAddActivity();
                        $scope.$emit('activitiesUpdated', $scope.activities);
                    } else {
                        ModalService.showError('gateway.directives.add-activity.Failed to create Activity');
                    }
                }, () => {
                    ModalService.showError('gateway.directives.add-activity.Failed to create Activity');
                });
            };

            $scope.setActivityInfo = (activityInfo) => {
                $scope.selectedActivityPattern = activityInfo;
                $scope.activityInfo.subject = activityInfo.subject;
                $scope.activityInfo.description = activityInfo.description;
                $scope.activityInfo.priority = activityInfo.priority;
                $scope.activityInfo.recurring = activityInfo.recurring;
                $scope.activityInfo.mandatory = activityInfo.mandatory;
                $scope.activityInfo.dueDate = activityInfo.dueDate;
                $scope.activityInfo.escalationDate = activityInfo.escalationDate;
                $scope.activityInfo.selectedAssignee = $scope.assignableUsers[0];
                $scope.activityInfo.activityPattern = {
                    'code': $scope.selectedActivityPattern.code,
                    'priority': $scope.selectedActivityPattern.priority
                };
            };

            /**
             * Get a policy icon or a policy type.
             * @param {String} priority
             * @returns {String}
             */
            $scope.getPriorityIcon = (priority) => {
                return `../styles/images/icons/priorities/${priority}_16px.png`;
            };

            $scope.cancel = () => {
                $scope.config.showAddActivity = false;
            };

            $scope.closeAddActivity = () => {
                $scope.config.showAddActivity = false;
            };

            $scope.setCreateActivityData();
            $scope.getActivityPatternsFor($scope.activityEntity);

            $scope.$on('$locationChangeStart', (event, newUrl /* , oldUrl*/) => {
                if ($scope.isVisible()) {
                    const title = 'gateway.directives.add-activity.Confirm Navigation';
                    const msg = 'gateway.directives.add-activity.Are you sure you want to stop creating a new activity';

                    ModalService.showWarning(title, msg, null, $filter('translate')('gateway.directives.GatewayDocuments.Yes'), null, $filter('translate')('gateway.directives.GatewayDocuments.No'))
                        .result.then(() => {
                            $scope.hideAddActivity()(false);
                            $location.path($location.url(newUrl).hash()); // Go to page they're interested in
                        });
                    // prevent navigation by default since we'll handle it
                    // once the user selects a dialog option
                    event.preventDefault();
                }
            });
        }]
    };
}];
